import React, { useEffect } from "react";
import "./Dashboard.css";

const Dashboard = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (!user) {
      window.location.href = "/login";
    }
  }, [user]);

  if (!user) return null;

  return (
    <div className="dashboard-page">
      <h2>Welcome, {user.first_name} 👋</h2>
      <p>Your account overview</p>

      <div className="dashboard-cards">
        <div className="dashboard-card">
          <h3>User Code</h3>
          <span>{user.user_code}</span>
        </div>

        <div className="dashboard-card">
          <h3>Wallet Balance</h3>
          <span>₹{user.wallet_balance}</span>
        </div>

        <div className="dashboard-card">
          <h3>User Type</h3>
          <span>{user.user_type}</span>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
